import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonAddressFormMeta, { ICommonAddressFormMeta } from "@Shared/containers/form/CommonAddressFormMeta";
import firstContactFormMeta, { IFirstContactFormMeta } from "./FirstContactFormMeta";
import secondContactFormMeta, { ISecondContactFormMeta } from "./SecondContactFormMeta";

export interface ISalesPointAddressFormMeta extends ICommonAddressFormMeta, IFirstContactFormMeta, ISecondContactFormMeta {
  
  schema: any;
}

let salesPointAddressFormMeta = {} as ISalesPointAddressFormMeta;

salesPointAddressFormMeta = {
  ...salesPointAddressFormMeta, ...commonAddressFormMeta, ...firstContactFormMeta, ...secondContactFormMeta
};

salesPointAddressFormMeta.schema = yup.object().shape(getValidationSchema(salesPointAddressFormMeta));

export default salesPointAddressFormMeta;